module.exports = __webpack_public_path__ + "static/media/dotBlue.33394731.svg";